/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';

export interface StockAdjustmentsControllerFindAll$Params {
  page?: number;
  limit?: number;
  productId?: string;
  reason?: 'DAMAGE' | 'EXPIRATION' | 'CONSUMPTION' | 'THEFT' | 'CORRECTION' | 'INVENTORY' | 'OTHER';

/**
 * Filter from date (ISO string)
 */
  dateFrom?: string;

/**
 * Filter to date (ISO string)
 */
  dateTo?: string;
}

export function stockAdjustmentsControllerFindAll(http: HttpClient, rootUrl: string, params?: StockAdjustmentsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, stockAdjustmentsControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('productId', params.productId, {});
    rb.query('reason', params.reason, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

stockAdjustmentsControllerFindAll.PATH = '/stock/adjustments';
